import iabCategories from '@/data/iabCategories.json';

export const IAB_CATEGORY_OPTIONS = iabCategories.map((item) => ({
  value: item.iabCode,
  label: `${item.iabCode}: ${item.category}`,
  bold: item.iabCode.indexOf('-') === -1,
}));
